__turbopack_context__.v({
  "bot": "style-module-scss-module__WnE0XG__bot",
  "button": "style-module-scss-module__WnE0XG__button",
  "content": "style-module-scss-module__WnE0XG__content",
  "gradientBorder": "style-module-scss-module__WnE0XG__gradientBorder",
  "icon": "style-module-scss-module__WnE0XG__icon",
  "iconWrapper": "style-module-scss-module__WnE0XG__iconWrapper",
  "image": "style-module-scss-module__WnE0XG__image",
  "invertColors": "style-module-scss-module__WnE0XG__invertColors",
  "top": "style-module-scss-module__WnE0XG__top",
});
